import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledTierTabSlider = styled.div`
  position: relative;
  width: 100%;
  min-height: ${toRem(48)};

  > div {
    border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']};
  }

  .glideOutlet {
    width: 100%;
    box-sizing: border-box;
  }

  .glide__track {
    overflow: hidden;
  }

  .benefits-arrow-left,
  .benefits-arrow-right {
    background: none;
    border-radius: unset;
    box-shadow: none;
    padding: 0;
    cursor: pointer;
    color: ${baseVariables.color.base10};

    &.is-disabled {
      opacity: 0;
      pointer-events: none;
      visibility: hidden;
    }

    &:after {
      font-size: ${toRem(24)};
    }
  }

  .glide__arrows > .benefits-arrow-left {
    left: 0;
  }

  .glide__arrows > .benefits-arrow-right {
    right: 0;
  }

  .tier-tab-slide {
    height: auto;
    list-style: none;
    background-color: none;
    box-shadow: none;
    border-radius: 0;
  }

  .tier-tab-button {
    appearance: none;
    background: none;
    border: none;
    margin: 0;
    padding: ${toRem(12)} ${toRem(8)} ${toRem(0)};
    padding-bottom: ${toRem(14)};
    color: ${baseVariables.color['neutral40']};
    border-bottom: ${toRem(3)} solid transparent;
    width: 100%;
    margin-bottom: ${toRem(-1)};

    &--active {
      color: ${baseVariables.color.base10};
      border-bottom: ${toRem(3)} solid ${baseVariables.color.base10};
    }
  }

  @media (max-width: 767px) {
    .tier-tab-slide {
      justify-content: center;
      text-align: center;
    }

    .tier-tab-button {
      text-align: center;
    }
  }
`;
